/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * Utility class used to chain RxJS operators.
 *
 * This class is the concrete implementation, but the type used by the user when chaining
 * is StrictRxChain. The strict chain enforces types on the operators to the same level as
 * the prototype-added equivalents.
 */
export class RxChain {
    /**
     * @param {?} _context
     */
    constructor(_context) {
        this._context = _context;
    }
    /**
     * Starts a new chain and specifies the initial `this` value.
     * @template O
     * @param {?} context Initial `this` value for the chain.
     * @return {?}
     */
    static from(context) {
        return new RxChain(context);
    }
    /**
     * Invokes an RxJS operator as a part of the chain.
     * @param {?} operator Operator to be invoked.
     * @param {...?} args Arguments to be passed to the operator.
     * @return {?}
     */
    call(operator, ...args) {
        this._context = operator.call(this._context, ...args);
        return this;
    }
    /**
     * Subscribes to the result of the chain.
     * @param {?} fn Callback to be invoked when the result emits a value.
     * @return {?}
     */
    subscribe(fn) {
        return this._context.subscribe(fn);
    }
    /**
     * Returns the result of the chain.
     * @return {?}
     */
    result() {
        return this._context;
    }
}
function RxChain_tsickle_Closure_declarations() {
    /** @type {?} */
    RxChain.prototype._context;
}
//# sourceMappingURL=rx-chain.js.map